import { $domain } from 'global';

export const storeObjectAsCookie = (
  key: string,
  data: object,
  maxAge: number = 365 * 24 * 60 * 60,
): void => {
  const cookieData = {
    [key]: escape(JSON.stringify(data)),
    ['max-age']: maxAge,
    domain: $domain,
    path: '/',
  };

  document.cookie = Object.entries(cookieData)
    .map(([key, value]) => `${key}=${value}`)
    .join(';');
};

export const parseObjectCookie = (key: string): object => {
  try {
    const cookieString = document.cookie
      .split(/; ?/)
      .find((s) => s.startsWith(key));
    if (!cookieString) return {};

    const serializedObject = unescape(cookieString.replace(`${key}=`, ''));
    return JSON.parse(serializedObject);
  } catch {
    // Worried about old cookies before the escape/unescape was added not being
    // parseable.
    return {};
  }
};
